// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SbpTransactionInfoAPIModel
 */
export interface SbpTransactionInfoAPIModel {
    /**
     * 
     * @type {string}
     * @memberof SbpTransactionInfoAPIModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SbpTransactionInfoAPIModel
     */
    bankId?: string;
    /**
     * 
     * @type {string}
     * @memberof SbpTransactionInfoAPIModel
     */
    senderInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof SbpTransactionInfoAPIModel
     */
    senderPhone?: string;
}

export function SbpTransactionInfoAPIModelFromJSON(json: any): SbpTransactionInfoAPIModel {
    return SbpTransactionInfoAPIModelFromJSONTyped(json, false);
}

export function SbpTransactionInfoAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SbpTransactionInfoAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'senderInfo': !exists(json, 'senderInfo') ? undefined : json['senderInfo'],
        'senderPhone': !exists(json, 'senderPhone') ? undefined : json['senderPhone'],
    };
}

export function SbpTransactionInfoAPIModelToJSON(value?: SbpTransactionInfoAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'bankId': value.bankId,
        'senderInfo': value.senderInfo,
        'senderPhone': value.senderPhone,
    };
}


